module.exports = __webpack_public_path__ + "media/alert.1506875c.mp3";